import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { OAuthConsentPage } from '@/pages/oauth-consent/oauth-consent-page';

/** Landing page of GET /api/oauth/authorize (one-click MCP connectors: claude.ai, ChatGPT…). */
const consentSearch = z.object({
  request: z.string().uuid().optional().catch(undefined),
  error: z.string().max(64).optional().catch(undefined),
});

export const Route = createFileRoute('/oauth/consent')({
  component: OAuthConsentPage,
  validateSearch: consentSearch,
});
